import React from "react";
import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import { titanStyle } from "../../../style/titan.theme.constant";
import golbalStyle from "../../../style/titanStyle";
import { Link } from "react-router-dom";
import { hasPermission } from "../../../services/hasPermission";
export default function Card(props) {
  //Delcare const get values for card
  const { col, title, height, redirectTo } = props.card;

  //style configuration
  const useStyles = makeStyles((theme) => ({
    cardLayout: {
      height: height,
      backgroundColor: "#ffffff",
      borderRadius: "4px",
      //   boxShadow:'0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
    },
    title: {
      fontSize: titanStyle.titan_fontSize.fontSize_14,
      fontWeight: titanStyle.titan_fontWeigth.fontWeigth_500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: titanStyle.titan_lineHeight.lineHeight_1_21,
      letterSpacing: "normal",
      textAlign: titanStyle.titan_textAlign._left,
      color: titanStyle.titan_color.color_black,
      paddingLeft: "18px",
    },
    paddingRghtZero: {
      paddingRight: "0px",
    },
    viewAll: {
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.17,
      letterSpacing: "normal",
      textAlign: "right",
      color: "01579b",
    },
  }));

  //use local style
  const classes = useStyles();
  //use global style
  const golbalClasses = golbalStyle();
  //Card Rendering
  return (
    <div className={classNames(col, classes.paddingRghtZero)}>
      <div className={classes.cardLayout}>
        <div className={"flex-box"}>
          <div className={classNames(classes.title, golbalClasses.padding_10)}>
            {title}
          </div>
          <div className={classNames(classes.title, golbalClasses.padding_10)}>
            {redirectTo !== undefined ? (
              <Link
                to={redirectTo}
                className={
                  classes.viewAll + props.card.type === "Diary" &&
                  hasPermission(["USER DIARY"])
                    ? "disabled-link"
                    : ""
                }
              >
                View All
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className={classes.content}>{props.children}</div>
      </div>
    </div>
  );
}
